import { useQuery } from "@tanstack/react-query";
import { ItemFragment } from "./fragments/item";
import { gqlReq } from "~/libs/gql";
import {
	GetActiveMenuItemDocument,
	GetActiveMenuItemQueryVariables,
} from "~/types/__generated/gql/graphql";
import { sortByOrderingIndex } from "~/utils/sort-by-ordering-index";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		query GetActiveMenuItem($id: ObjectID!) {
			getActiveMenuItem(id: $id) {
				...ItemFragment
			}
		}
		${ItemFragment}
	`
);

export const getActiveMenuItemQueryKey = (
	variables: GetActiveMenuItemQueryVariables,
) => ["getActiveMenuItem", variables];

export const getActiveMenuItemQueryFn = async (
	variables: GetActiveMenuItemQueryVariables,
	signal?: AbortSignal,
) =>
	gqlReq({
		document: GetActiveMenuItemDocument,
		variables,
		signal,
	}).then((res) => {
		return {
			...res,
			options: res.options.sort(sortByOrderingIndex),
			option_groups: res.option_groups
				.sort(sortByOrderingIndex)
				.map((g) => ({ ...g, options: g.options.sort(sortByOrderingIndex) })),
		};
	});

export const useGetActiveMenuItem = (
	variables: Partial<GetActiveMenuItemQueryVariables>,
) => {
	return useQuery({
		enabled: !!variables.id,
		queryKey: getActiveMenuItemQueryKey({
			...variables,
		} as GetActiveMenuItemQueryVariables),
		queryFn: ({ signal }) =>
			getActiveMenuItemQueryFn(
				{
					...variables,
				} as GetActiveMenuItemQueryVariables,
				signal,
			),
	});
};

export const getActiveMenuItemCache = async (
	variables: GetActiveMenuItemQueryVariables,
) => {
	return queryClient.ensureQueryData({
		queryKey: getActiveMenuItemQueryKey(variables),
		queryFn: ({ signal }) => getActiveMenuItemQueryFn(variables, signal),
	});
};
